export default __webpack_public_path__ + "static/background-hero-home-inter-asset-lg-457d547663f10e1c6b55e662799dcc24.png";